import { render, staticRenderFns } from "./reviewpage.vue?vue&type=template&id=c116b280&scoped=true&"
import script from "./reviewpage.vue?vue&type=script&lang=js&"
export * from "./reviewpage.vue?vue&type=script&lang=js&"
import style0 from "./reviewpage.vue?vue&type=style&index=0&id=c116b280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c116b280",
  null
  
)

export default component.exports